import React, { Component } from 'react';

export default class ArrowRight extends Component {
  render () {
    return (
      <svg
        width='19'
        height='20'
        viewBox='0 0 19 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1 10H17'
          stroke='#2B5266'
          strokeWidth='1.5'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
        <path
          d='M10 2L18 10L10 18'
          stroke='#2B5266'
          strokeWidth='1.5'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
      </svg>
    );
  }
}
